import { Component, Input, OnInit } from '@angular/core';
import { NgZone } from '@angular/core';
declare var $: any; 

@Component({
  selector: 'app-scora-doc-pdf-view',
  templateUrl: './scora-doc-pdf-view.component.html',
  styleUrls: ['./scora-doc-pdf-view.component.css']
})
export class ScoraDocPdfViewComponent implements OnInit {
  
  @Input() answers: any;
  seleteData =''
  constructor(private zone: NgZone) { }

  ngOnChanges() {
    console.log(this.answers,"****************")
    
  }
  ngOnInit() {
  }

  pdf_popup(data) {
   
    this.zone.run(() => {
      this.seleteData = data;
      setTimeout(() => {
        $('#pdf-view').modal('show');
    }, 500); // Small delay to ensure Angular processes the change
   
    });
   
    // this.isShowModal = !this.isShowModal;
  }

  isPDF(url) {
    // console.log(url)
    // return true
    return url.toLowerCase().endsWith(".pdf");
}
getExtension(url) {
  return url.split('.').pop();
}

}



// WEBPACK FOOTER //
// ./src/app/application/core-module/scora-common-module/scora-doc-pdf-view/scora-doc-pdf-view.component.ts